module.exports = __webpack_public_path__ + "static/media/builderBannerContent.2d4459ce.svg";